import { useState } from 'react';
import { Ad } from '@foundation/sparkle/lib/types';

import { AdStatus } from '../types';

type RenderedAd = {
  adRendered?: Ad;
  sizeRendered?: string;
  onAdRender: (ad: Ad) => void;
  adStatus: AdStatus;
  onEmptyRender: () => void;
};

type UseAdRenderedProps = {
  onAdRender?: (ad: Ad) => void;
  onEmptyRender?: () => void;
};

const useAdRendered = (props: UseAdRenderedProps): RenderedAd => {
  const [adRendered, setAdRendered] = useState<Ad>();
  const [sizeRendered, setSizeRendered] = useState<string>();
  const [adStatus, setAdStatus] = useState<AdStatus>('rendering');

  const onAdRender = (ad: Ad) => {
    setAdRendered(ad);
    setSizeRendered(ad.getSlotRenderedEvent()?.getSize().join('x'));
    setAdStatus('rendered');
    props.onAdRender?.(ad);
  };

  const onEmptyRender = () => {
    setAdStatus('empty');
    props.onEmptyRender?.();
  };

  return {
    adRendered,
    sizeRendered,
    onAdRender,
    adStatus,
    onEmptyRender,
  };
};

export default useAdRendered;
